import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit,
  NgZone,
} from "@angular/core";
import { Router } from "@angular/router";
import { ConfigService } from "src/app/config/config.service";
import { AuthService } from "src/app/core/service/auth.service";
import { RightSidebarService } from "src/app/core/service/rightsidebar.service";
import { LanguageService } from "src/app/core/service/language.service";
import { UserAccount } from "src/app/shared/models/user-account";
import { NgxSpinnerService } from "ngx-spinner";
import { NotificationService } from "src/app/shared/notification.service";
import { UserRole } from "src/app/shared/models/user-role";
import { userRole } from "src/app/shared/userRole";
import { BehaviorSubject } from "rxjs";
import { AppService } from "src/app/core/service/app.service";
import { ActivityType } from "src/app/shared/ActivityType";
const document: any = window.document;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.sass"],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public config: any = {};
  userImg: string;
  homePage: string;
  isNavbarCollapsed = true;
  flagvalue;
  countryName;
  langStoreValue: string;
  defaultFlag: string;
  isOpenSidebar: boolean;
  userAccount: UserAccount;
  userFullName: string;
  userRole: string;
  unreadCount: number;
  userType: string;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private rightSidebarService: RightSidebarService,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    public languageService: LanguageService,
    private spinner: NgxSpinnerService,
    private notificationService: NotificationService,
    private _ngZone: NgZone,
    private appService: AppService
  ) {
    this.userAccount = new UserAccount();
  }
  listLang = [
    { text: "English", flag: "assets/images/flags/us.jpg", lang: "en" },
    { text: "Spanish", flag: "assets/images/flags/spain.jpg", lang: "es" },
    { text: "German", flag: "assets/images/flags/germany.jpg", lang: "de" },
  ];
  notifications: any[] = [];
  ngOnInit() {
    this.appService.userDetails.subscribe({
      next: (resp: any) => {
        this.userAccount = resp;
        if (this.userAccount != null) {
          this.userFullName =
            this.userAccount.FirstName + " " + this.userAccount.LastName;
        }
      },
    });
    this.userAccount = JSON.parse(sessionStorage.getItem("CurrentUser"));
    this.config = this.configService.configData;
    const userRole = this.GetRole(this.userAccount.UserRoleId);
    this.userRole = userRole;
    // this.userImg = this.authService.currentUserValue.img;

    if (userRole === "Admin") {
      this.homePage = "admin/dashboard/main";
    } else if (userRole === "Doctor") {
      this.homePage = "doctor/dashboard";
    } else if (userRole === "Pharmacist") {
      this.homePage = "pharmacist/dashboard";
    } else if (userRole === "PharmacySubAdmin") {
      this.homePage = "pharmacist/dashboard";
    } else {
      this.homePage = "admin/dashboard/main";
    }

    this.langStoreValue = localStorage.getItem("lang");
    const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.defaultFlag = "assets/images/flags/us.jpg";
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
    this.userFullName =
      this.userAccount.FirstName + " " + this.userAccount.LastName;
    // this.config = this.configService.configData;
    // const userRole = this.authService.currentUserValue.role;
    // this.userImg = this.authService.currentUserValue.img;

    // if (userRole === "Admin") {
    //   this.homePage = "admin/dashboard/main";
    // } else if (userRole === "Patient") {
    //   this.homePage = "patient/dashboard";
    // } else if (userRole === "Doctor") {
    //   this.homePage = "doctor/dashboard";
    // } else {
    //   this.homePage = "admin/dashboard/main";
    // }

    // this.langStoreValue = localStorage.getItem("lang");
    // const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    // this.countryName = val.map((element) => element.text);
    // if (val.length === 0) {
    //   if (this.flagvalue === undefined) {
    //     this.defaultFlag = "assets/images/flags/us.jpg";
    //   }
    // } else {
    //   this.flagvalue = val.map((element) => element.flag);
    // }
    this.GetNotifications();
    this.subscribeToEvents();
  }

  ngAfterViewInit() {
    // set theme on startup
    this.userAccount = JSON.parse(sessionStorage.getItem("CurrentUser"));
    if (localStorage.getItem("theme")) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(this.document.body, localStorage.getItem("theme"));
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(this.document.body, "theme-white");
    }

    if (localStorage.getItem("menuOption")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("menuOption")
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "menu_" + this.config.layout.sidebar.backgroundColor
      );
    }

    if (localStorage.getItem("choose_logoheader")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("choose_logoheader")
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "logo-" + this.config.layout.logo_bg_color
      );
    }

    if (localStorage.getItem("sidebar_status")) {
      if (localStorage.getItem("sidebar_status") === "close") {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      } else {
        this.renderer.removeClass(this.document.body, "side-closed");
        this.renderer.removeClass(this.document.body, "submenu-closed");
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      }
    }
  }
  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    this.languageService.setLanguage(lang);
  }
  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains("side-closed");
    if (hasClass) {
      this.renderer.removeClass(this.document.body, "side-closed");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    } else {
      this.renderer.addClass(this.document.body, "side-closed");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }
  public toggleRightSidebar(): void {
    this.rightSidebarService.sidebarState.subscribe((isRunning) => {
      this.isOpenSidebar = isRunning;
    });

    this.rightSidebarService.setRightSidebar(
      (this.isOpenSidebar = !this.isOpenSidebar)
    );
  }
  // logout() {
  //   this.authService.logout().subscribe((res) => {
  //     if (!res.success) {
  //       this.router.navigate(["/authentication/signin"]);
  //     }
  //   });
  // }
  GetRole(roleId) {
    if (roleId == 1) {
      return "Admin";
    } else if (roleId == 2) {
      this.userType = "doctor";
      return "Doctor";
    } else if (roleId == 3) {
      this.userType = "pharmacist";
      return "Pharmacist";
    } else if (roleId == 4) {
      this.userType = "pharmacist";
      return "PharmacySubAdmin";
    }
  }
  logout() {
    this.AddUserActivity();
  }

  GetNotifications() {
    var userDetails = {
      receiverAccountId: this.userAccount.Id,
      receiverRoleId: this.userAccount.UserRoleId,
    };
    this.spinner.show();
    this.notificationService.ListNotification(userDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasError) {
          this.notifications = resp.Rows;
          this.unreadCount = this.notifications?.filter(
            (x) => x.IsRead == false
          ).length;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
  timeSince(date) {
    date = new Date(date + "Z");
    var seconds = Math.floor((new Date().valueOf() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

  private subscribeToEvents(): void {
    this.notificationService.notificationRecived.subscribe((resp: any) => {
      this._ngZone.run(() => {
        if (this.notifications.length == 10) {
          this.GetNotifications();
        } else {
          if (
            resp.ReceiverAccountId == this.userAccount.Id ||
            resp.ReceiverRoleId == this.userAccount.UserRoleId ||
            (resp.ReceiverRoleId == userRole.pharmacist &&
              this.userAccount.UserRoleId == userRole.pharmacistSubAdmin)
          )
            this.notifications.unshift(resp);
          this.unreadCount = this.notifications?.filter(
            (x) => x.IsRead == false
          ).length;
        }
      });
    });
  }
  private UpdateNotification(notification: any) {
    if (notification.IsRead == false) {
      notification.IsRead = true;
      notification.ModifiedById = this.userAccount.Id;
      var notificationDetails = {
        Notification: notification,
      };
      this.spinner.show();
      this.notificationService
        .UpdateNotification(notificationDetails)
        .subscribe({
          next: (res: any) => {
            if (!res.HasError) {
              this.spinner.hide();
              this.GetNotifications();
            } else {
              this.spinner.hide();
            }
          },
          error: () => {
            this.spinner.hide();
          },
        });
    }
  }
  AddUserActivity() {
    var userActivity = {
      ActivityType: ActivityType.Logout,
      ActivityName: "User Logout",
      UserName: this.userAccount.FirstName + " " + this.userAccount.LastName,
      Description:
        this.userAccount.FirstName +
        " " +
        this.userAccount.LastName +
        " logged out",
      UserAccountId: this.userAccount.Id,
    };
    this.appService.AddUserActivity(userActivity).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          localStorage.removeItem("CurrentUser");
          sessionStorage.removeItem("CurrentUser");
          this.router.navigate(["/authentication/signin"]);
        } else {
          localStorage.removeItem("CurrentUser");
          sessionStorage.removeItem("CurrentUser");
          this.router.navigate(["/authentication/signin"]);
        }
      },
      error: () => {
        localStorage.removeItem("CurrentUser");
        sessionStorage.removeItem("CurrentUser");
        this.router.navigate(["/authentication/signin"]);
      },
    });
  }
}
